import React from "react";

export const UiSplitImages = (props) => {
    return (
        <>
            <div className="sb-split-images">
                {
                    props.images.map((image, i) => (
                        <img src={image} key={i} />
                    ))
                }
                {
                    props.lastChild &&
                    <div className="sb-split-images__last-item">
                        {props.lastChild}
                    </div>
                }
            </div>
        </>
    )
}